import styled, { css } from 'styled-components'

import { mainColors } from '../../../../styles'
import { mobileMediaQuery } from '../../../../utils'
import { REVIEW_CARD_MAX_WIDTH } from '../../ReviewTimeline.styles'

interface ReviewCardContainerProps {
  isLastReview?: boolean
  isLastReviewOnPage?: boolean
}

export const ReviewCardContainer = styled.div<ReviewCardContainerProps>`
  width: 100%;
  max-width: ${REVIEW_CARD_MAX_WIDTH}px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 18px 0;

  ${({ isLastReview, isLastReviewOnPage }) =>
    !isLastReviewOnPage &&
    `
  border-bottom: 1px solid;
  border-color: ${isLastReview ? mainColors.neutralDark : mainColors.neutralMedium};
  padding-bottom: ${isLastReview ? 40 : 20}px;
`}
`

export const ReviewBreakdownContainer = styled.div<{ shouldDisplayAsColumn?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${({ shouldDisplayAsColumn }) => (shouldDisplayAsColumn ? '16px' : '24px')};
  ${({ shouldDisplayAsColumn }) => shouldDisplayAsColumn && 'flex-direction: column'};

  ${mobileMediaQuery`
    flex-flow: column;
    align-items: flex-start;
    gap: 10px;
  `}
`

export const DetailedRatingsRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 30px;
  flex-grow: 1;
`

export const DetailedRatingsColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  flex-wrap: wrap;
  gap: 16px 24px;
  width: 100%;
`

export const ReplyActionDivider = styled.div`
  width: 1px;
  height: 12px;
  background-color: ${mainColors.neutralDark};
`

export const ReviewCommentContainer = styled.div<{ $shouldDisplayAsColumn?: boolean }>`
  display: flex;
  flex-direction: ${({ $shouldDisplayAsColumn }) => ($shouldDisplayAsColumn ? 'column' : 'row')};
  flex-wrap: wrap;
  gap: 12px;

  ${({ $shouldDisplayAsColumn }) =>
    !$shouldDisplayAsColumn &&
    css`
      > div {
        min-width: max-content;
      }
    `}
`
